import * as types from "../../mutation-types";

export default {
    [types.FETCH_ADMIN_DATA_SUCCESS] (state, { data }) {
        state.adminData = data
    },

    [types.FETCH_ADMIN_DATA_FAILURE] (state) {
        state.adminData = null
    },

    [types.FETCH_REGIMEN_DATA_SUCCESS] (state, { data }) {
        state.regimenData = data
    },

    [types.FETCH_REGIMEN_DATA_FAILURE] (state) {
        state.regimenData = null
    },

    [types.FETCH_DELETE_USER_SUCCESS] (state, data) {
        var index = state.adminData.findIndex(e => e.id === data.id);
        state.adminData.splice(index,1);
    },

    [types.FETCH_DELETE_USER_FAILURE] (state) {
        state.deleteUser = null
    },

    [types.SET_EDITED_USER_ID] (state, userId) {
        state.editUserId = userId
    },

    [types.FETCH_ROLES_SUCCESS] (state, data) {
        state.roles = data
    },

    [types.FETCH_ROLES_FAILURE] (state) {
        state.roles = null
    },

    [types.EDIT_USER_SUCCESS] (state, data){
        state.adminData = data
    },

    [types.FETCH_USER_INFO_SUCCESS](state, data) {
        state.getUser = data
    },

    [types.FETCH_ALL_NOTES_SUCCESS](state, data){
        state.notesData = data
    },

    [types.FETCH_ALL_INSIGHT_SUCCESS](state, data){
        state.insightData = data
    },

    [types.FETCH_DELETE_REGIMEN_SUCCESS] (state, data) {
        var index = state.adminData.findIndex(e => e.id === data.id);
        state.adminData.splice(index,1);
    },

    [types.FETCH_DELETE_REGIMEN_FAILURE] (state) {
        state.deleteUser = null
    },
}


// WEBPACK FOOTER //
// ./src/store/modules/admin/mutations.js